module.exports = __webpack_public_path__ + "static/media/trackingIconWhite.ec7bf3ba.png";